import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { RouterConstant } from "../../routers/index";
import { useLayoutContext } from "../../layouts/general-layout";
import ChatHeader from "../../components/chat-header";
import Button from "../../components/button";
import { useUserStore } from "../../utils/userStore";
import "./payment.scss";

export default function PaymentStatus() {
  const { t } = useLayoutContext();
  const { ROUTERS_PATH } = RouterConstant;
  const navigate = useNavigate();
  const location = useLocation();
  const { response, success } = location.state || {};
  const isSuccess = response?.success === true || success === true;
  const isTrial = response?.is_trial === true;

  const { isOnboarded } = useUserStore.getState();

  const handleContinue = () => {
    if (isSuccess) {
      navigate(isOnboarded() ? ROUTERS_PATH.USER_MAIN_DASHBOARD : ROUTERS_PATH.V2_ONBOARDING);
    } else {
      navigate(ROUTERS_PATH.CHOOSEPACKAGES);
    }
  };

  return (
    <div className="full-template payment-page">
      <ChatHeader chatHeading={t("payment_status")} hideBack={true} onBackClick={() => { }} />
      <div className="success-content">
        <div className={`status-message ${isTrial ? 'trial' : isSuccess ? 'success' : 'failed'}`}>
          <h2>
            {isTrial
              ? t("trial_activated")
              : isSuccess
                ? t("payment_success")
                : t("payment_failed")
            }
          </h2>
          <p className="message-text">
            {isTrial
              ? ''
              : isSuccess
                ? response?.message || t("payment_success_message")
                : response?.message || t("payment_failed_message")
            }
          </p>
          {!isTrial && isSuccess && response?.transaction_id && (
            <p>{t("Transaction_ID")}: {response.transaction_id}</p>
          )}
        </div>
        <div className="payment-footer">
          <Button
            text={t(isSuccess || isTrial ? "continue_to_system" : "try_again")}
            color="blue"
            onClick={handleContinue}
            className="proceed_to_payment_button"
          />
        </div>
      </div>
    </div>
  );
}
